import script from "./billInvoiceView.vue?vue&type=script&setup=true&lang=js"
export * from "./billInvoiceView.vue?vue&type=script&setup=true&lang=js"

import "./billInvoiceView.vue?vue&type=style&index=0&id=eb4cc4d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb4cc4d8"]])

export default __exports__